import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { css } from '@emotion/react';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var longTextWrap = function longTextWrap() {
  var maxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  word-wrap: break-word;\n  max-width: ", ";\n"])), maxWidth);
};

var hiddenTextNowrap = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  overflow: hidden;\n"])));
var longTextEllipsis = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n\n  text-overflow: ellipsis;\n"])), hiddenTextNowrap);

var longTextEllipsisMultiline = function longTextEllipsisMultiline() {
  var maxLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"])), longTextWrap(), maxLines);
};

var mixins = {
  longTextWrap: longTextWrap,
  hiddenTextNowrap: hiddenTextNowrap,
  longTextEllipsis: longTextEllipsis,
  longTextEllipsisMultiline: longTextEllipsisMultiline
};

export { mixins as m };
